import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../contexts/authContext";
import { useNavigate, useLocation } from 'react-router-dom';

import { Badge, Modal, Button, Group } from '@mantine/core';

import NavbarApp from "../../../components/Navbar/NavbarApp";
import ChatPanel from "./ChatPanel";

// Pour une Vente/Don, offer.status === "booked" reflète déjà l'attente de validation du
// vendeur. Pour une Location, l'offre reste "open" globalement même avec une demande en
// attente (elle peut avoir plusieurs réservations sur des créneaux différents), donc il
// faut se baser sur le statut de la transaction liée à cette conversation précise.
const needsSellerValidation = (conv, isSeller) => {
    if (!isSeller) return false;
    if (conv.offer?.contrat === "Location") {
        return conv.transaction?.status === "funds_secured";
    }
    return conv.offer?.status === "booked";
};

const ConversationsList = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [conversations, setConversations] = useState([]);
    const [userId, setUserId] = useState();
    const [selectedConversationId, setSelectedConversationId] = useState(null);
    const [conversationToDelete, setConversationToDelete] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const getUser = async () => {
        try {
            const token = getToken();
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
            // const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/s/getUser', {

                method: "GET",    
                headers: {
                    Authorization: `Bearer ${token}`
                    }
        });
                const data = await response.json()
                setUserId(data._id)
        }   catch (error) {
            return null;
        }
    }

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getUser();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
      
          window.addEventListener('resize', handleResize);
      
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Permet à une autre page (ex: "Contacter l'annonceur" depuis une offre) de pré-
    // sélectionner une conversation précise à l'arrivée sur cette liste, via
    // /app/msg/list?conv=<id>.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const conv = params.get("conv");
        if (conv) setSelectedConversationId(conv);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    useEffect(() => {
        if (!userId) return;

        const fetchConversations = async () => {
            try {
            const token = getToken();

            const response = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/msg/conversations",
                {
                headers: {
                    Authorization: `Bearer ${token}`
                }
                }
            );

            const data = await response.json();
            setConversations(data);

            } catch (err) {
            console.error(err);
            }
        };

        fetchConversations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, location]);


    const hideConversation = async (conversationId) => {
        try {
            const token = getToken();

            const res = await fetch(
            `https://boldee-97d8d36af3bd.herokuapp.com/app/msg/conversations/${conversationId}/hide`,
            {
                method: "POST",
                headers: {
                Authorization: `Bearer ${token}`
                }
            }
            );

            if (!res.ok) {
            console.error("Erreur suppression conversation");
            return;
            }

            setConversations(prev =>
            prev.filter(conv => conv._id !== conversationId)
            );

        } catch (err) {
            console.error(err);
        }
    };

    const confirmDeleteConversation = async () => {
        if (!conversationToDelete) return;
        await hideConversation(conversationToDelete);
        if (selectedConversationId === conversationToDelete) setSelectedConversationId(null);
        setConversationToDelete(null);
    };

    return (
        <>
        {isMobile ? (
            <div>
                <NavbarApp />

                <div className="conversations-container topBorder">

                    {conversations.length === 0 && (
                        <div className='vertical txtCenter noMrgTB'>
                            <p className='dGreyT mrgT30 mrgB5 txt15'>Aucun message</p>
                        </div>
                    )}

                    {conversations.map(conv => {

                        const myUnread = conv.unreadCount?.[userId] || 0;

                        const lastMessageSenderId = conv.lastMessage?.from?.toString();

                        const isLastMessageMine =
                            lastMessageSenderId === userId?.toString();

                        const hasUnread =
                            myUnread > 0 &&
                            conv.lastMessage &&
                            !isLastMessageMine;

                        const isSeller = !!userId && conv.offer?.author?._id?.toString() === userId?.toString();

                        const otherPartyName = isSeller
                            ? conv.participants?.find(p => p._id?.toString() !== userId)?.company?.name
                            : conv.offer?.author?.company?.name;
                    return (
                        <div
                        key={conv._id}
                        className={`conversation-item ${hasUnread ? "unread-item" : ""}`}
                        onClick={() =>
                            navigate(`/app/msg/chat/${conv._id}`)
                        }
                        >

                        <button
                            className="delete-conversation-btn"
                            onClick={(e) => {
                            e.stopPropagation();
                            setConversationToDelete(conv._id);
                            }}
                        >
                            ×
                        </button>

                        <div className="conversation-avatar">
                            {otherPartyName?.charAt(0)?.toUpperCase()}
                        </div>

                        <div className="conversation-content">

                            <span className="conversation-title medium txt13 horizontal iCenter">
                            <span className="mrgR5 medium">{otherPartyName}</span>
                                {!isSeller && conv.offer?.status === "close" && (
                                <Badge size="sm" color="green">Terminé</Badge>
                                )}
                                {needsSellerValidation(conv, isSeller) && (
                                <Badge size="sm" color="red">À valider</Badge>
                                )}

                                {isSeller && conv.offer?.status === "deal" && (
                                <Badge size="sm" color="orange">En cours</Badge>
                                )}

                                {isSeller && conv.offer?.status === "close" && (
                                <Badge size="sm" color="green">Terminé</Badge>
                                )}
                            </span>

                            <div className="conversation-header">

                            <span className="conversation-title bold txt13">
                                {conv.offer?.title}
                            </span>

                            <div className="conversation-meta">

                                {conv.updatedAt && (
                                <span className="conversation-date">
                                    {new Date(conv.updatedAt).toLocaleDateString()}
                                </span>
                                )}

                                {hasUnread && (
                                <span className="unread-badge">
                                    {myUnread}
                                </span>
                                )}

                            </div>
                            </div>
                
                            <div className="conversation-preview">
                                {conv.lastMessage?.content || " "}
                            </div>
                            

                        </div>
                        </div>
                    );
                    })}

                </div>
            </div>
        ) : (
            <div>
                <NavbarApp />

                <div className="desktop-messages-layout">

                    <div className="conversations-container conversations-list-pane">

                        {conversations.length === 0 && (
                            <div className='vertical txtCenter noMrgTB'>
                                <p className='dGreyT mrgT30 mrgB5 txt15'>Aucun message</p>
                            </div>
                        )}

                    {conversations.map(conv => {

                        const myUnread = conv.unreadCount?.[userId] || 0;

                        const lastMessageSenderId = conv.lastMessage?.from?.toString();

                        const isLastMessageMine =
                            lastMessageSenderId === userId?.toString();

                        const hasUnread =
                            myUnread > 0 &&
                            conv.lastMessage &&
                            !isLastMessageMine;

                        const isSeller = !!userId && conv.offer?.author?._id?.toString() === userId?.toString();

                    const otherPartyName = isSeller
                            ? conv.participants?.find(p => p._id?.toString() !== userId)?.company?.name
                            : conv.offer?.author?.company?.name;

                    return (
                        <div
                        key={conv._id}
                        className={`conversation-item ${hasUnread ? "unread-item" : ""} ${selectedConversationId === conv._id ? "conversation-item-active" : ""}`}
                        onClick={() => {
                            setSelectedConversationId(conv._id);
                            setConversations(prev =>
                                prev.map(c =>
                                    c._id === conv._id
                                        ? { ...c, unreadCount: { ...c.unreadCount, [userId]: 0 } }
                                        : c
                                )
                            );
                        }}
                        >

                        <button
                            className="delete-conversation-btn"
                            onClick={(e) => {
                            e.stopPropagation();
                            setConversationToDelete(conv._id);
                            }}
                        >
                            ×
                        </button>

                        <div className="conversation-avatar">
                            {otherPartyName?.charAt(0)?.toUpperCase()}
                        </div>

                        <div className="conversation-content">

                            <span className="conversation-title medium txt13 horizontal iCenter">
                            <span className="mrgR5">{otherPartyName}</span>
                                {!isSeller && conv.offer?.status === "close" && (
                                <Badge size="sm" color="green">Terminé</Badge>
                                )}
                                {needsSellerValidation(conv, isSeller) && (
                                <Badge size="sm" color="red">À valider</Badge>
                                )}

                                {isSeller && conv.offer?.status === "deal" && (
                                <Badge size="sm" color="orange">En cours</Badge>
                                )}

                                {isSeller && conv.offer?.status === "close" && (
                                <Badge size="sm" color="green">Terminé</Badge>
                                )}
                            </span>

                            <div className="conversation-header">

                            <span className="conversation-title bold txt13">
                                {conv.offer?.title}
                            </span>

                            <div className="conversation-meta">

                                {conv.updatedAt && (
                                <span className="conversation-date">
                                    {new Date(conv.updatedAt).toLocaleDateString()}
                                </span>
                                )}

                                {hasUnread && (
                                <span className="unread-badge">
                                    {myUnread}
                                </span>
                                )}

                            </div>
                            </div>

                            <div className="conversation-preview">
                                {conv.lastMessage?.content || " "}
                            </div>


                        </div>
                        </div>
                    );
                    })}

                    </div>

                    <div className="conversations-detail-pane">
                        {selectedConversationId ? (
                            <ChatPanel conversationId={selectedConversationId} hideHeaderBack />
                        ) : (
                            <div className="vertical txtCenter noMrgTB conversations-detail-empty">
                                <p className='dGreyT txt15'>Sélectionnez une conversation pour afficher les messages</p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        )}

        <Modal
            opened={!!conversationToDelete}
            onClose={() => setConversationToDelete(null)}
            withCloseButton={false}
            centered
            size="auto"
        >
            <p className="noMrgTB txt15">Supprimer cette conversation ?</p>
            <Group mt="xl" className="horizontal jCenter" style={{ gap: 12 }}>
                <Button variant="outline" color="dark" onClick={() => setConversationToDelete(null)}>
                    Annuler
                </Button>
                <Button variant="filled" color="dark" onClick={confirmDeleteConversation}>
                    Supprimer
                </Button>
            </Group>
        </Modal>
        </>
    )
};

export default ConversationsList;